// Preserve the API's existing identifier while the portal uses its Admin name.
export const SMARTSELL_ADMIN_ENVIRONMENT = 'SMARTSELL_WEB' as const;
